import React, {useContext, useState} from 'react'
import {useParams} from "react-router";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import PropTypes from "prop-types";
import UploadFile from "components/UploadFile";
import OfferEspdExternalUploadFileTypes from "./OfferEspdExternalUploadFileTypes";
import Tr from "translations/Translations";
import OfferSectionContext from "context/OfferSectionContext";
import PurchaserOfferContext from "context/PurchaserOfferContext";


function OfferEspdExternalUploadFile(
    {
        dealingId,
        positionItems,
        offerEdit,
        disabled
    }) {
    const params = useParams();
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [configuredFiles, setConfiguredFiles] = useState(null);
    const [portFilesWorking, setPostFilesWorking] = useState(false);

    const section = useContext(OfferSectionContext);

    const handleSendFiles = (uploadedFiles, config) => {
        setConfiguredFiles(null);
        if (uploadedFiles.length) {
            const tab = uploadedFiles.map((x, i) => ({
                positionId: !config || !config[`position${x.originalIndex}`] ? null : config[`position${x.originalIndex}`],
                file: x
            }));
            setPostFilesWorking(true);
            DemandOffersOfferService.postOfferEspdFiles(params.id, params.stageId, purchaserOfferContext?.supplierId, tab)
                .finally(()=> setPostFilesWorking(false));
        }
    }

    const handleSubmitSelectDocumentTypes = (values) => {
        setConfiguredFiles({files: selectedFiles, config: values})
        setSelectedFiles(null);
    };

    return (
        <>
            {
                offerEdit.espdOnPositions ?
                    <UploadFile
                        label={Tr('espd_external_step_2')}
                        onOpenConfigureFiles={(files) => setSelectedFiles(files)}
                        configuredFiles={configuredFiles}
                        onUploadPopupClosed={handleSendFiles}
                        encryptRoundId={section.encryptionEnabled ? section.roundId : undefined}
                        disabled={disabled}
                        working={portFilesWorking}
                    /> :
                    <UploadFile
                        label={Tr('espd_external_step_2')}
                        onUploadPopupClosed={handleSendFiles}
                        encryptRoundId={section.encryptionEnabled ? section.roundId : undefined}
                        disabled={disabled}
                        working={portFilesWorking}
                    />
            }

            {!!selectedFiles && <OfferEspdExternalUploadFileTypes
                items={selectedFiles}
                onCancel={() => setSelectedFiles(null)}
                onSubmit={handleSubmitSelectDocumentTypes}
                isPublished={false}
                positionItems={positionItems}
                dealingId={dealingId}
            />}
        </>
    )
}

OfferEspdExternalUploadFile.propTypes = {
    positionItems: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    })).isRequired,
};

export default OfferEspdExternalUploadFile;